// extracted by mini-css-extract-plugin
module.exports = {"TermsDetails":"AboutUs_TermsDetails__1MFhr","mainParagraph":"AboutUs_mainParagraph__30d9v"};